import { ReactNode } from 'react';
import {
	IconFactory,
	ICON_CHAT_BUBBLE_LINE,
	ICON_CROWN_LINE,
	ICON_CROWN_LINE_VIP,
	ICON_DEALER,
	ICON_DIAMOND_LINE,
	ICON_DICES,
	ICON_CASINO_SEVEN,
	ICON_DOCUMENT_SEARCH_LINE,
	ICON_GIFT_LINE,
	ICON_GLOBE_LINE,
	ICON_INFO,
	ICON_OPEN_BOOK,
	ICON_SHOP_LINE,
	ICON_SHOP_PENDING_LINE,
	ICON_SUPPORT_LINE,
	ICON_TROPHY_LINE,
	ICON_TROPHY_PLAY_LINE,
	ICON_TSHIRT_LINE,
	ICON_WE_SPIN,
	ICON_TVBET,
	ICON_FOOTBALL_LINE,
	ICON_VIRTUALS,
	ICON_SPORTSBOOK,
	ICON_FOOTBALL,
	ICON_FREE_TO_PLAY
} from '~/components/icon/index';

const Icons = IconFactory([
	ICON_CHAT_BUBBLE_LINE,
	ICON_CROWN_LINE,
	ICON_CROWN_LINE_VIP,
	ICON_DEALER,
	[ICON_DIAMOND_LINE, { className: 'icon-dices' }],
	ICON_DICES,
	ICON_CASINO_SEVEN,
	ICON_DOCUMENT_SEARCH_LINE,
	ICON_GIFT_LINE,
	ICON_GLOBE_LINE,
	ICON_INFO,
	ICON_OPEN_BOOK,
	ICON_SHOP_LINE,
	ICON_SHOP_PENDING_LINE,
	ICON_SUPPORT_LINE,
	ICON_TROPHY_LINE,
	ICON_TROPHY_PLAY_LINE,
	ICON_TSHIRT_LINE,
	[ICON_WE_SPIN, { className: 'u-object-fit-fill' }],
	ICON_TVBET,
	ICON_FOOTBALL_LINE,
	ICON_VIRTUALS,
	ICON_SPORTSBOOK,
	ICON_FOOTBALL,
	ICON_FREE_TO_PLAY
]) as Record<string, ReactNode>;

export {
	Icons,
	ICON_CHAT_BUBBLE_LINE,
	ICON_CROWN_LINE,
	ICON_CROWN_LINE_VIP,
	ICON_DEALER,
	ICON_DIAMOND_LINE,
	ICON_DICES,
	ICON_CASINO_SEVEN,
	ICON_DOCUMENT_SEARCH_LINE,
	ICON_GIFT_LINE,
	ICON_GLOBE_LINE,
	ICON_INFO,
	ICON_OPEN_BOOK,
	ICON_SHOP_LINE,
	ICON_SHOP_PENDING_LINE,
	ICON_SUPPORT_LINE,
	ICON_TROPHY_LINE,
	ICON_TROPHY_PLAY_LINE,
	ICON_TSHIRT_LINE,
	ICON_WE_SPIN,
	ICON_TVBET,
	ICON_FOOTBALL_LINE,
	ICON_VIRTUALS,
	ICON_SPORTSBOOK,
	ICON_FOOTBALL,
	ICON_FREE_TO_PLAY
};
